export function shouldHideBecomeMemberButton(isMember: boolean, currentUrl: string): boolean {
  // List of URL substrings that should hide the CTA in the footer.
  const membershipPaths = ['bli-medlem', 'medlemskap'];
  const url = currentUrl?.toLowerCase() || '';
  const onMembershipPath = membershipPaths.some((path) => url.includes(path));
  return isMember || onMembershipPath;
}
